module.exports = __webpack_public_path__ + "static/media/Tier_1.a3bd2b93.png";